'use client'

import Link from '@/components/Link'
import { usePathname } from 'next/navigation'
import React, { ReactNode } from 'react'

type TBreadCrumbProps = {
  homeElement: ReactNode
  separator: ReactNode
  containerClasses?: string
  listClasses?: string
  activeClasses?: string
  capitalizeLinks?: boolean
}

const BreadCrumb = ({
  homeElement,
  separator,
  containerClasses,
  listClasses,
  activeClasses,
  capitalizeLinks,
}: TBreadCrumbProps) => {
  const paths = usePathname()
  const pathNames = paths.split('/').filter((path) => path)

  return (
    <div className={containerClasses}>
      <ul className="flex flex-wrap items-center space-x-2 sm:items-start">
        {pathNames.length > 0 &&
          pathNames.map((link, index) => {
            let href = `/${pathNames.slice(0, index + 1).join('/')}`

            // Check for special case and modify href accordingly
            if (pathNames[0] === 'blog' && index === 1) {
              href = `/tags/${pathNames[1].toLocaleLowerCase()}`
            }

            let itemClasses = paths === href ? `${listClasses} ${activeClasses}` : listClasses
            let itemLink = link.replace(/-/g, ' ') // Remove hyphens from the text
            itemLink = capitalizeLinks
              ? itemLink.charAt(0).toUpperCase() + itemLink.slice(1)
              : itemLink

            return (
              <React.Fragment key={index}>
                <li className={`${itemClasses} inline-flex items-center`}>
                  <Link
                    href={href}
                    removeRoughNotationWrapper={true}
                    normalText={true}
                    className=" hover:text-secondary-500 dark:hover:text-primary-300 "
                  >
                    {itemLink}
                  </Link>
                </li>
                {pathNames.length !== index + 1 && (
                  <li className="inline-flex items-center">{separator}</li>
                )}
              </React.Fragment>
            )
          })}
      </ul>
    </div>
  )
}

export default BreadCrumb
